var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87186 11.2494L4.76827 11.3554L4.8731 11.4602L9.8731 16.4602L9.97917 16.5663L10.0852 16.4602L15.1061 11.4394L15.2109 11.3346L15.1073 11.2285L14.2323 10.3327L14.1263 10.2241L14.0189 10.3314L10.7542 13.5962L10.7542 3L10.7542 2.85L10.6042 2.85L9.35417 2.85L9.20417 2.85L9.20417 3L9.20417 13.5962L5.96023 10.3523L5.85291 10.2449L5.74686 10.3535L4.87186 11.2494Z",
    fill: "#1F36C7",
    stroke: "#1F36C7",
    strokeWidth: 0.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 16.3333,
    y2: 18,
    stroke: "#1F36C7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.4f7e518b0d35e39100e64f3b2a3aa12a.svg";
export { ForwardRef as ReactComponent };